module.exports = __webpack_public_path__ + "img/avatar.5abc2ffc.jpeg";